import { render, staticRenderFns } from "./index.vue?vue&type=template&id=03d0a85e"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03d0a85e')) {
      api.createRecord('03d0a85e', component.options)
    } else {
      api.reload('03d0a85e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=03d0a85e", function () {
      api.rerender('03d0a85e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/pages/email-quarantine/table/index.vue"
export default component.exports